export const DIRECTION = {
  ASCENDING: 'ascending',
  DESCENDING: 'descending',
  ASC: 'ascending',
  DESC: 'descending'
}

/**
 * Comparator function creator
 * @param {string} property Property name to compare
 * @param {string} [direction] Sort direction of DIRECTION object
 * @return {function} Comparator function
*/

export function createComparator(property, direction) {
  if (isNaS(property)) {
    throw new TypeError('Property must be a string.')
  }

  let sortDirection = 1

  if (direction === DIRECTION.DESC) {
    sortDirection = -1
  }

  /**
   * Comparator function
   * @param {string} left Left value of the compared pair
   * @param {string} right Right value of the compared pair
   * @return {number} Compared value
  */

  return function comparator(left, right) {
    let a = left[property],
        b = right[property]

    if ((isNaN(a) || isNaN(b)) && (isNaS(a) || isNaS(b))) {
      if (a === undefined) { // eslint-disable-line
        throw new TypeError(`Property ${property} is not defined on the target object.`)
      }
      throw new TypeError(`Expected both arguments to be of the same type strings or numbers. Was ${typeof a}, ${typeof b}.`) // eslint-disable-line
    }

    if (isString(a)) {
      a = a.toLowerCase()
      b = b.toLowerCase()
    }

    if (a < b) {
      return -sortDirection
    }

    if (a > b) {
      return sortDirection
    }

    return 0
  }
}

// function helper isNotAString, similar to isNaN
function isNaS(value) {
  return !isString(value)
}

function isString(value) {
  return typeof value === 'string'
}

export default createComparator



// WEBPACK FOOTER //
// ./src/client/utils/comparator.js